<template>
    <!-- Page header -->
    <div>
        <div class="page-header page-header-light">
            <div class="page-header-content header-elements-md-inline">
                <div class="page-title d-flex">
                    <h4><span class="font-weight-semibold">Suppresion list</span></h4>
                </div>
            </div>
        </div>
        <!-- /page header -->
        <!-- Content area -->
        <div class="content">
            <div class="card">
                <div class="table-responsive" :class="{ 'loading-mask': loading }">
                    <button v-if="type !== 'deferral'" @click="showUpload = true" class="btn btn-primary pull-left"
                        style="margin: 10px"
                        v-tooltip="'Upload a CSV file with only one column which is an email address or TXT file with one address per line'">Upload</button>
                    <button v-if="type !== 'deferral'" @click="showUploadDelete = true" class="btn btn-danger pull-left"
                        style="margin: 10px"
                        v-tooltip="'Upload a CSV file with only one column which is an email address or TXT file with one address per line, those addresses will be removed from suppression/bounce/spam lists'">Upload
                        for delete</button>
                    <button @click="downloadCsv" class="btn btn-primary pull-right" style="margin: 10px">Download
                        CSV</button>
                    <button @click="load" class="btn btn-primary pull-right" style="margin: 10px">Refresh list</button>
                    <button :disabled="page >= pages" @click="offset = (pages - 1) * limit; load()"
                        class="btn btn-primary pull-right" style="margin: 10px">Last page >></button>
                    <button :disabled="page >= pages" @click="nextPage" class="btn btn-primary pull-right"
                        style="margin: 10px">Next page >></button>
                    <button :disabled="true" class="btn btn-primary pull-right" style="margin: 10px">Page: {{ page }} /
                        {{ pages }} (count: {{ count }})</button>
                    <button :disabled="offset <= 0" @click="prevPage" class="btn btn-primary pull-right"
                        style="margin: 10px">
                        << Previous page</button> <button :disabled="offset <= 0" @click="offset = 0; load()"
                                class="btn btn-primary pull-right" style="margin: 10px">
                                << First page</button> <input placeholder="Search by text"
                                        style="border: 1px solid grey; margin-top: 10px" type="text"
                                        class="col-2 form-control pull-right" v-model="query" />
                                    <div style="float:left; margin-top: 10px">
                                        <datetime type="datetime" :input-class="'form-control'"
                                            :placeholder="'Choose `from` date'"
                                            style="margin-left: 20px; float:left; width:200px" v-model="from">
                                        </datetime>
                                        <datetime type="datetime" :input-class="'form-control'"
                                            :placeholder="'Choose `to` date'"
                                            style="margin-left: 20px; float:left; width:200px" v-model="to"></datetime>
                                        <button @click="removeByDate" class="btn btn-danger pull-right"
                                            :class="{ disabled: count > 10000 }" style="margin: 10px">Remove by selected
                                            dates (max 10 000)</button>
                                    </div>
                                    <table class="table table-striped table-xs" style="min-height: 100px">
                                        <thead>
                                            <tr>
                                                <th>No.</th>
                                                <th>{{ type === 'deferral' ? 'Domain' : 'Email' }}</th>
                                                <th v-if="type === 'deferral'">Account</th>
                                                <th>Type</th>
                                                <th>Source</th>
                                                <th>Expires at</th>
                                                <th>Created at</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="r, k in rows">
                                                <td style="width:10px">{{ k + 1 }}</td>
                                                <td>{{ type === 'deferral' ? r.domain : r.email }}</td>
                                                <td v-if="type === 'deferral'">{{ r.account.name }} ({{
        r.account.provider
}})
                                                </td>
                                                <td>{{ r.type }}</td>
                                                <td>{{ r.source }}</td>
                                                <td>{{ r.expire_at | formatDate }}</td>
                                                <td>{{ r.created_at | formatDate }}</td>
                                                <td>
                                                    <button @click="remove($event, r._id)"
                                                        class="btn btn-sm btn-danger">Remove</button>
                                                </td>
                                            </tr>
                                            <h2 v-if="rows.length === 0"> </h2>
                                        </tbody>
                                    </table>
                </div>
            </div>
        </div>
        <!-- /content area -->
        <upload v-if="showUpload" :url="'upload_suppression_list/' + $route.params.type" @close="showUpload = false"
            @reload="load()" />
        <upload v-if="showUploadDelete" :url="'suppresion_list/remove_file'" @close="showUploadDelete = false"
            @reload="load()" />
        <!-- /content area -->
    </div>
</template>
<script>
let queryDebounce
import moment from 'moment'
import EventBus from '@/event_bus'
import Upload from './modal/Upload'
export default {
    components: { Upload },
    data() {
        return {
            showUpload: false,
            showUploadDelete: false,

            from: moment().subtract(1, 'day').toISOString(),
            to: moment().toISOString(),

            rows: [],
            loading: true,
            adding: false,
            limit: 25,
            offset: 0,
            count: 0,
            query: null
        }
    },
    watch: {
        '$route.params.type'() {
            this.load()
        },
        from() {
            this.load()
        },
        to() {
            this.load()
        },
        query() {

            if (queryDebounce) {
                clearTimeout(queryDebounce)
            }

            queryDebounce = setTimeout(() => {
                this.offset = 0
                this.load()
            }, 500)
        },
    },
    computed: {
        type() {
            return this.$route.params.type
        },
        pages() {
            if (this.count <= this.limit) {
                return 1
            }

            return Math.ceil(this.count / this.limit)
        },
        page() {
            if (this.offset === 0) {
                return 1
            }
            return (this.offset / this.limit) + 1 || 1
        },
    },
    methods: {
        downloadCsv() {
            this.$confirm({ message: 'Confirm CSV export' }).then(() => {

                let u = this.$api.getUrl() + 'suppression_list/' + this.$route.params.type + '/download/csv'

                window.open(u)
                this.$notify.addWarning('Generating CSV please wait...')
            })
        },
        removeByDate() {

            if (this.count > 10000) {
                return
            }

            this.$confirm().then(() => {
                this.$api.deleteReq('suppression_list/by_date/' + this.$route.params.type, {
                    from: this.from,
                    to: this.to
                }).then(() => {
                    this.$notify.addSuccess('contacts deleted')
                    this.load()
                }).catch(err => {
                    this.$notify.addError(err)
                })
            })
        },
        remove(_, id) {
            this.$confirm().then(() => {
                this.$api.deleteReq('suppression_list/' + id).then(() => {
                    this.$notify.addSuccess('contact deleted')
                    this.load()
                }).catch(err => {
                    this.$notify.addError(err)
                })
            })
        },
        prevPage() {
            this.offset -= 25
            this.load()
        },
        nextPage() {
            this.offset += 25
            this.load()

        },
        load() {
            this.loading = true
            this.$api.getReq(`suppression_list/${this.$route.params.type}`, {
                limit: this.limit,
                offset: this.offset,
                query: this.query || '',
                from: this.from,
                to: this.to
            }).then(res => {
                this.rows = res.body.data
                this.count = res.body.count
                this.loading = false
            })
        }
    },
    destroyed() { },
    mounted() {
        this.load()
    }
}
</script>
<style>
.avsquare {
    width: 7px;
    height: 100%;
    float: left;
    cursor: pointer;
    border-left: 1px solid rgba(0, 0, 0, .1);
}

.avsquare:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

.avsquare:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

tbody .btn {
    padding: 3px 11px;
}
</style>


// WEBPACK FOOTER //
// src/components/SuppressionList.vue